export const reminderColumns = [
    {
        field: "activeTo",
        headerName: "ActiveTo",
        width: 160,
    },
    {
        field: "activeFrom",
        headerName: "ActiveFrom",
        width: 160,
    },
    {
        field: "timeSlot",
        headerName: "Time Slot",
        width: 120
    },
    {
        field: "reminderSMS",
        headerName: "Reminder SMS",
        width: 130,
    },
    {
        field: "followUpCall",
        headerName: "FollowUp Call",
        width: 120,
    },
    // {
    //     field: "done",
    //     headerName: "Done",
    //     width: 120,
    // },
    // {
    //     field: "notDone",
    //     headerName: "Not Done",
    //     width: 120,
    // },
    {
        field: "serviceName",
        headerName: "Service Name",
        width: 160,
    },
    {
        field: "category",
        headerName: "Category",
        width: 120,
    },
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "number",
        headerName: "User Number",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
  ];